import EmailCont from '../../../../components/Common/Email/EmailCont'
import RemittanceLinesCont from '../../../../components/Purchasing/Remittance/AddRemittance/Lines/RemittanceLinesCont'
import RemittanceForm from '../../../../components/Purchasing/Remittance/AddRemittance/RemittanceForm'
import style from '../../../../components/Sales/style.css'
import CustomSpin from '../../../../elements/CustomSpin'
import IconText from '../../../../elements/IconText'
import Status from '../../../../elements/Status'
import Authentication from '../../../../modules/Authentication'
import { idMaker, strVal } from '../../../../modules/Utils'
import React, { Fragment } from 'react'
import { Modal, Popconfirm, Row, Tabs } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import _ from 'lodash'
import { streamUrl } from '../../../../variables'
import DocumentsCont from '../../../../components/Common/Documents/DocumentsCont'

const { TabPane } = Tabs
const auth = new Authentication()
const ids = idMaker()

function RemittanceModal (props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
    remittance,
    actions,
    handleActions,
    fetchingActions,
    onShowEmail,
    visibleEmail,
    onCancelEmail,
    emailTemplate,
    emailDetails,
    emailFiles,
    emailLines,
  } = props

  const isNew = modalType === 'new'
  const isConfirmed = ['Confirmed'].includes(remittance.status)
  const isUpdatable = actions.find(a => a.key === 'update')
  const Operations = ({ remittance, ...rest }) => {
    const ops = actions
      .filter(a => a.key !== 'update' && a.key !== 'remove')
      .map(a => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    if (ops.length > 0 && !isConfirmed) {
      ops.push(
        <a
          target={'_blank'}
          href={`${streamUrl}pdf/${remittance._id}?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'}/>
        </a>,
      )
    }
    if (ops.length > 0 && isConfirmed) {
      ops.push(
        <a onClick={onShowEmail}>
          <IconText text={'Send Email'} type={'mail'}/>
        </a>,
      )
    }

    return (
      <div {...rest}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr])
          : []}
      </div>
    )
  }
  return (
    <Modal
      visible={visible}
      title={'Remittance'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Remittance'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
      />
      <CustomSpin spinning={fetchingActions}>
        <h3 className={style.title}>
          {!isNew && (
            <Fragment>
              <Status value={_.capitalize(remittance.status)}/>
              <Operations
                style={{ marginTop: '10px' }}
                remittance={remittance}
                status={strVal(remittance, 'status')}
              />
            </Fragment>
          )}
        </h3>
      </CustomSpin>
      <Tabs defaultActiveKey="form">
        <TabPane tab="Form" key="form">
          <Row>
            <RemittanceForm ref={formRef} {...props} />
            <RemittanceLinesCont remittance={remittance}/>
          </Row>
        </TabPane>
        <TabPane disabled={modalType !== 'edit'} tab={'Lines'} key="#lines">
          <RemittanceLinesCont remittance={remittance}/>
        </TabPane>
        <TabPane disabled={modalType !== 'edit'} tab={'Files'} key="#files">
          <DocumentsCont owner={remittance} email={true} category={false} editable={isUpdatable}/>
        </TabPane>
      </Tabs>
    </Modal>
  )
}

RemittanceModal.propTypes = {}
RemittanceModal.defaultProps = {}

export default RemittanceModal
